import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../../ModalComponent";
import { useUserState } from "../../../../providers/UserProvider";
import * as HTTPServices from "../../../../api/HTTPServices";
import _ from "lodash";

const Index = ({
  handleOpenPrescriptions,
  handleClosePrescriptions,
  audienceId,
  visitToken,
}) => {
  const { t } = useTranslation();
  const user = useUserState();
  const [files, setFiles] = useState([]);

  const userType = user?.user_login?.approve;

  useEffect(() => {
    const fetchFIle = () => {
      const RequestService = HTTPServices.getMethod(
        "chat",
        "audience=" + audienceId + "&token=" + visitToken,
        "true"
      );

      RequestService.then(function (response) {
        if (response) {
          let res = response;
          let newPrescription = [];

          _.map(res, (item) => {
            if (
              item.type === "prescriptionPhoto" ||
              item.type === "prescriptionFile" ||
              item.type === "prescriptionVoice" ||
              item.type === "prescriptionVideoMessage"
            ) {
              newPrescription.push(item);
            }
          });
          setFiles(newPrescription);
        }
      }).catch(function (error) {});
    };
    fetchFIle();
  }, [audienceId, visitToken]);
  return (
    <ModalComponent
      open={handleOpenPrescriptions}
      handleClose={handleClosePrescriptions}
      closeBtn={true}
      confirmBtn={false}
      handleOk={null}
      title={t("components.AppointmentRoom.RoomHeader.PrescriptionModal.title")}
    >
      {files.length > 0 ? (
        // <ItemFile
        //   AddDeleteAttach={AddDeleteAttach}
        //   Files={files}
        //   UserId={UserLogin.client_id}
        // />
        "asd"
      ) : (
        <div>
          <div>
            <div>
              <div>
                <figure>
                  {/* <img src={DossierIcon} alt="nothing found" /> */}
                  <figcaption>
                    <p>
                      {t(
                        "components.AppointmentRoom.RoomHeader.PrescriptionModal.p1"
                      )}
                    </p>
                    {userType && userType === "doctor" && (
                      <p>
                        {t(
                          "components.AppointmentRoom.RoomHeader.PrescriptionModal.p2"
                        )}
                      </p>
                    )}
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      )}
    </ModalComponent>
  );
};

export default Index;
